import React, { useState, useEffect, ChangeEvent } from 'react';
import i18n from '../../../translate/i18n';

import TextareaEditor from '../../Form/TextareaEditor';
import Radio from '../../Form/Radio';
import Select from '../../Form/Select';
import Input from '../../Form/Input';

import { RelatoCroqui } from '../../../services/Report';
import UploadFiles from 'components/Form/UploadFiles';

interface TypeProps {
  data: any,
  handleSelectChange: Function,
  handleInputChange: Function,
  setData: Function,
}

export default function Croqui({ data, handleSelectChange, handleInputChange, setData }: TypeProps) {


  const [relato, setRelato] = useState('')

  useEffect(() => {
    async function setInitialData() {
      if (data?.relatoCroqui)
        await setRelato(data?.relatoCroqui)
    }

    setInitialData()
  }, [])


  // atualiza relato automatico
  const relatoAutomatico = (event: any) => {
    event.preventDefault();
    RelatoCroqui(data).then(res => {
      setRelato(res);
    })
  }

  useEffect(() => {
    setData({ ...data, 'relatoCroqui': relato })
  }, [relato])


  return (
    <div className='container-box'>
      <h5>{i18n.t<string>('edit.local search')}</h5>
      <hr />
      <form >
        <Input
          name="endereco"
          label="Endereço"
          type="text"
          placeholder={'Endereço'}
          data={data?.endereco || ''}
          setData={handleInputChange}
          disabled={true}
        />
        {data.locationFilename && <img src={`${process.env.REACT_APP_API_URL}/locations/streetview/${data.locationFilename}`} width='100%' />}
        <Select
          title="Local do Sinistro"
          data={[
            { _id: 'rodEstadual', name: 'Rodovia Estadual' },
            { _id: 'rodFederal', name: 'Rodovia Federal' },
            { _id: 'avenida', name: 'Avenida' },
            { _id: 'rua', name: 'Rua' },
            { _id: 'vicinal', name: 'Vicinal' },
            { _id: 'fechado', name: 'Fechado' },
          ]}
          value={data?.localSinistro || ''}
          setSelected={(value: string) => { handleSelectChange('localSinistro', value) }}
        />
        <Radio
          title="Via"
          data={[
            { _id: 'publica', name: 'Pública' },
            { _id: 'privada', name: 'Privada' },
          ]}
          value={data?.via || ''}
          setSelected={(value: string) => { handleSelectChange('via', value) }}
        />
        <Select
          title="Faixa de Rolamento"
          data={[
            { _id: 'duplo', name: 'Sentido Duplo' },
            { _id: 'unico', name: 'Único' },
            { _id: 'tresFaixas', name: 'Três faixas' },
            { _id: 'quatroFaixas', name: 'Quatro Faixas' },
          ]}
          value={data?.mao || ''}
          setSelected={(value: string) => { handleSelectChange('mao', value) }}
        />
        <Radio
          title="Pavimentação"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.pavimentacao || ''}
          setSelected={(value: string) => { handleSelectChange('pavimentacao', value) }}
        />
        <Select
          title="Trecho em"
          data={[
            { _id: 'reta', name: 'Reta' },
            { _id: 'curva', name: 'Curva' },
            { _id: 'rotatoria', name: 'Rotatória' },
            { _id: 'semSaida', name: 'Sem saída' },
          ]}
          value={data?.tipoTrecho || ''}
          setSelected={(value: string) => { handleSelectChange('tipoTrecho', value) }}
        />
        <Select
          title="Nível"
          data={[
            { _id: 'plano', name: 'Plano' },
            { _id: 'aclive', name: 'Aclive' },
            { _id: 'declive', name: 'Declive' },
          ]}
          value={data?.nivel || ''}
          setSelected={(value: string) => { handleSelectChange('nivel', value) }}
        />
        <Radio
          title="Sinalização"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.sinalizacao || ''}
          setSelected={(value: string) => { handleSelectChange('sinalizacao', value) }}
        />
        <Radio
          title="Canteiro"
          data={[
            { _id: 'central', name: 'Central' },
            { _id: 'lateral', name: 'Lateral' },
          ]}
          value={data?.canteiro || ''}
          setSelected={(value: string) => { handleSelectChange('canteiro', value) }}
        />
        <Radio
          title="Acostamento"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.acostamento || ''}
          setSelected={(value: string) => { handleSelectChange('acostamento', value); }}
        />
        <Radio
          title="Permissão Estacionar"
          data={[
            { _id: 'sim', name: 'Permitido' },
            { _id: 'nao', name: 'Não permitido' },
          ]}
          value={data?.permissaoEstacionar || ''}
          setSelected={(value: string) => { handleSelectChange('permissaoEstacionar', value) }}
        />
        <Select
          title="Área"
          data={[
            { _id: 'residencial', name: 'Residencial' },
            { _id: 'comercial', name: 'Comercial' },
            { _id: 'comunidade', name: 'Comunidade' },
            { _id: 'rural', name: 'Rural' },
            { _id: 'chacara', name: 'Chácara' },
          ]}
          value={data?.area || ''}
          setSelected={(value: string) => { handleSelectChange('area', value) }}
        />
        <Radio
          title="Iluminação "
          data={[
            { _id: 'poste', name: 'Poste' },
            { _id: 'artificial', name: 'Artificial' },
          ]}
          value={data?.iluminacao || ''}
          setSelected={(value: string) => { handleSelectChange('iluminacao', value) }}
        />
        <Radio
          title="Testemunhas"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.testemunhas || ''}
          setSelected={(value: string) => { handleSelectChange('testemunhas', value) }}
        />
        <Radio
          title="Monitoramento"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.monitoramento || ''}
          setSelected={(value: string) => { handleSelectChange('monitoramento', value) }}
        />
        <Radio
          title="Vigilância"
          data={[
            { _id: 'sim', name: 'Sim' },
            { _id: 'nao', name: 'Não' },
          ]}
          value={data?.vigilancia || ''}
          setSelected={(value: string) => { handleSelectChange('vigilancia', value) }}
        />

        <Radio
          title="Local"
          data={[
            { _id: 'habitado', name: 'Habitado' },
            { _id: 'ermo', name: 'Ermo' },
          ]}
          value={data?.local || ''}
          setSelected={(value: string) => { handleSelectChange('local', value) }}
        />



        <button onClick={(event: any) => relatoAutomatico(event)} className='btn btn-secundary w-100'>Relato padrão</button>
        <TextareaEditor
          name="relatoCroqui"
          label="Relato"
          placeholder={'Relato'}
          data={relato || ''}
          setData={(value: string) => { setRelato(value) }}
        />
        {
          data.id &&
          <UploadFiles
            name="images"
            label="Inserir imagens e/ou documentos dos tipos: PNG, JPEG, JPG e PDF"
            osId={data?.id}
            etapa={'croqui'}
          />
        }
      </form>
    </div>
  )
}
